import React from "react";
import AnimateLines from "@/components/AnimateLine";
import AdaptiveImage from "@/components/AdaptiveImage";

import { AnimateProps } from "../../../types";

import "./index.css";

const Part7: React.FC<AnimateProps> = (props) => {
  const { data } = props;

  return (
    <div className="part_contain part_contain_9">
      <div className="part_content pc_contain">
        <div>
          <AnimateLines animateType={props.type}>
            <p className="text_title mb_40">Your Favorites</p>
            <p className="mb_16">
              <span className="text_content">Owned </span>
              <span className="text_num">
                {data.top_hold.collection_name} x{data.top_hold.balance}
              </span>
            </p>
            {data.top_hold.rank ? (
              <p className="mb_16">
                <span className="text_content">Top Holder</span>&ensp;
                <span className="text_num">#{data.top_hold.rank}</span>
              </p>
            ) : (
              <span />
            )}
            <p className="text_content">This must be the jewel of your palm!</p>
          </AnimateLines>
        </div>

        <div>
          <AnimateLines animateType={props.type} animateName="animate__fadeIn">
            <div
              className="avatar1111 mb_24"
              style={{
                backgroundImage: `url(${data.top_hold.collection_image_url})`,
              }}
            />
            <div className="Frame101041">
              <AdaptiveImage name="Frame101041" />
            </div>
          </AnimateLines>
        </div>
      </div>
      <div className="mobile_contain">
        <div style={{ flex: 1, width: "100%" }} />
        <div className="part_content">
          <AnimateLines animateType={props.type}>
            <p className="text_title mb_40">Your Favorites</p>
            <div
              className="avatar1111 mb_24"
              style={{
                backgroundImage: `url(${data.top_hold.collection_image_url})`,
              }}
            />
            <p className="mb_16">
              <span className="text_content">Owned </span>
              <span className="text_num">
                {data.top_hold.collection_name} x{data.top_hold.balance}
              </span>
            </p>
            {data.top_hold.rank ? (
              <p className="mb_16">
                <span className="text_content">Top Holder</span>&ensp;
                <span className="text_num">#{data.top_hold.rank}</span>
              </p>
            ) : (
              <span />
            )}
            <p className="text_content">This must be the jewel of your palm!</p>
          </AnimateLines>
        </div>
        <div style={{ flex: 1, width: "100%" }} />
        <AnimateLines animateType={props.type} animateName="animate__fadeIn">
          <div className="Frame101041">
            <AdaptiveImage name="Frame101041" />
          </div>
        </AnimateLines>
        <div style={{ flex: 2, width: "100%" }} />
      </div>
    </div>
  );
};

export default Part7;
